var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Chỉnh sửa cấu hình đăng nhập",
        visible: _vm.visible,
        width: "600px",
        "before-close": _vm.handleClose,
        top: "6vh",
        "close-on-click-modal": false,
        "custom-class": "login-config-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        open: _vm.handleOpen,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "formData",
          staticClass: "login-config-form",
          attrs: {
            model: _vm.formData,
            rules: _vm.rules,
            "label-position": "left",
            "label-width": "130px",
          },
        },
        [
          _c("div", { staticClass: "login-config-content" }, [
            _c(
              "div",
              { staticClass: "login-config-panel" },
              [
                _c("div", { staticClass: "login-config-panel-head" }, [
                  _c("div", { staticClass: "panel-icon" }, [
                    _c("i", { staticClass: "el-icon-edit" }),
                  ]),
                  _c("div", [
                    _c("p", { staticClass: "panel-title" }, [
                      _vm._v("Cập nhật cấu hình hiện có"),
                    ]),
                    _c("p", { staticClass: "panel-subtitle" }, [
                      _vm._v(
                        "Điều chỉnh dữ liệu cấu hình và lưu lại để áp dụng cho trang đăng nhập."
                      ),
                    ]),
                  ]),
                ]),
                _c(
                  "el-form-item",
                  { attrs: { label: "Key", prop: "configKey" } },
                  [
                    _c("el-input", {
                      attrs: {
                        "prefix-icon": "el-icon-collection-tag",
                        placeholder: "Nhập key",
                        clearable: "",
                      },
                      model: {
                        value: _vm.formData.configKey,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "configKey", $$v)
                        },
                        expression: "formData.configKey",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "Loại media", prop: "mediaType" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { placeholder: "Chọn loại media" },
                        model: {
                          value: _vm.formData.mediaType,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "mediaType", $$v)
                          },
                          expression: "formData.mediaType",
                        },
                      },
                      _vm._l(_vm.mediaTypeOptions, function (t) {
                        return _c("el-option", {
                          key: t.value,
                          attrs: { label: t.label, value: t.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "Giá trị", prop: "configValue" } },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        rows: 3,
                        placeholder: "Nhập giá trị cấu hình",
                      },
                      model: {
                        value: _vm.formData.configValue,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "configValue", $$v)
                        },
                        expression: "formData.configValue",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "Nhóm", prop: "groupName" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { placeholder: "Chọn nhóm cấu hình" },
                        model: {
                          value: _vm.formData.groupName,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "groupName", $$v)
                          },
                          expression: "formData.groupName",
                        },
                      },
                      _vm._l(_vm.groupNameOptions, function (group) {
                        return _c("el-option", {
                          key: group.value,
                          attrs: { label: group.label, value: group.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "Thứ tự ưu tiên", prop: "orderPriority" } },
                  [
                    _c("el-input-number", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        min: 0,
                        max: 9999,
                        disabled: _vm.isOrderPriorityDisabled,
                      },
                      model: {
                        value: _vm.formData.orderPriority,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "orderPriority", $$v)
                        },
                        expression: "formData.orderPriority",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "Trạng thái", prop: "active" } },
                  [
                    _c("el-switch", {
                      attrs: {
                        "active-text": "Hoạt động",
                        "inactive-text": "Ngừng",
                      },
                      model: {
                        value: _vm.formData.active,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "active", $$v)
                        },
                        expression: "formData.active",
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "login-config-note" }, [
                  _c("i", { staticClass: "el-icon-info" }),
                  _c("span", [
                    _vm._v(
                      "Kiểm tra lại  key, loại media và thứ tự ưu tiên trước khi cập nhật để tránh ảnh hưởng hiển thị."
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer login-config-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              staticClass: "btn-cancel",
              attrs: { type: "danger" },
              on: { click: _vm.handleClose },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _c("span", [_vm._v("Đóng")]),
            ]
          ),
          _c(
            "el-button",
            {
              staticClass: "btn-save",
              attrs: { loading: _vm.loading, type: "success" },
              on: { click: _vm.handleSubmit },
            },
            [
              _c("i", { staticClass: "el-icon-circle-check" }),
              _c("span", [_vm._v("Cập nhật")]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }